var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWalking(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m680.82 298.59c0 38.043-30.84 68.883-68.883 68.883-38.043 0-68.883-30.84-68.883-68.883 0-38.043 30.84-68.883 68.883-68.883 38.043 0 68.883 30.84 68.883 68.883"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m819.88 923.92v-0.015625c-0.75391-3.9844-64.266-180.76-64.266-180.76l-95.945-97.699v-198.32c0-45.047-81.715-74.469-91.273-67.863-6.2734 4.332-150 93.539-150 93.539l-15.242 151.76c-0.1875 1.3984-0.31641 2.7969-0.31641 4.2383 0 17.125 13.883 31.008 31.008 31.008s31.008-13.883 31.008-31.008l12.824-115.57 71.414-41.586v173.23l131.05 126.36 66.879 173.26c5.4648 14.305 19.277 24.477 35.496 24.477 21 0 38.035-17.035 38.035-38.02 0.007812-2.4141 0.007812-3.4766-0.67188-7.0391z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m388.53 899.29c-5.6602 6.6445-9.0898 15.234-9.0898 24.637 0 20.992 17.035 38.027 38.027 38.027 13.422 0 25.188-6.9688 31.961-17.473l116.31-150.46 35.77-79.094-58.816-55.121-43.477 88.715z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m676.64 525.53s-1.1641 85.418 0 83.656c1.0195-1.5352 43.008 33.312 53.812 42.32 0.79297 0.75 1.625 1.4375 2.4922 2.0938 0.015625 0 0.03125 0.015625 0.03125 0.015625 5.168 3.8828 11.586 6.1953 18.555 6.1953 17.109 0 31-13.883 31-31.008 0-11.539-6.2734-18.66-15.688-26.926z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalking);
export default __webpack_public_path__ + "static/media/walking.ea56fb1388ca3ba857c7fb39af02edf1.svg";
export { ForwardRef as ReactComponent };